var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 12,
    viewBox: "0 0 27 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1364 9.54549V11.9091H6.40909C3.14559 11.9091 0.5 9.26354 0.5 6.00003C0.5 2.73653 3.14559 0.0909424 6.40909 0.0909424H11.1364V2.45458H6.40909C4.45099 2.45458 2.86364 4.04193 2.86364 6.00003C2.86364 7.95814 4.45099 9.54549 6.40909 9.54549H11.1364ZM15.8635 2.45458V0.0909424H20.5908C23.8543 0.0909424 26.4999 2.73653 26.4999 6.00003C26.4999 9.26354 23.8543 11.9091 20.5908 11.9091H15.8635V9.54549H20.5908C22.5489 9.54549 24.1362 7.95814 24.1362 6.00003C24.1362 4.04193 22.5489 2.45458 20.5908 2.45458H15.8635ZM7.59091 4.81829V7.18192H19.4091V4.81829H7.59091Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.769c7b9a3bab80cc09002c7d58417426.svg";
export { ForwardRef as ReactComponent };